import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../assets/css/topo_mobile.css";
import { changeAbaNode } from "../main/home/homeActions";
import { producaov2 } from "../services/apis";
import {
  getToken, getUSER, isAuthenticated, IS_ADMIN_SET, IS_EMPRESA_SET, setUSER
} from "../services/auth";
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import separa_em_area_corporativa from "../utils/home_functions/separa_em_area_corporativa";
import { abrevia_nome } from "../utils/Utils";

class Topo_Mobile_logoff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: null,
      menu_deslogado_1: false,
      categorias: [
        {
          name: "Lean Seis Sigma",
          icon: "https://files.voitto.com.br/icon-lean.png",
          id: 1,
          area: "lean-seis-sigma",
        },
        {
          name: "Excelência Operacional",
          icon: "https://files.voitto.com.br/icon-excelencia.png",
          id: 2,
          area: "excelencia-operacional",
        },
        {
          name: "Softwares de Gestão",
          icon: "https://files.voitto.com.br/icon-softwares.png",
          id: 3,
          area: "softwares-de-gestao",
        },
        {
          name: "Sistemas de Gestão",
          icon: "https://files.voitto.com.br/icon-sistemas.png",
          id: 4,
          area: "sistemas-de-gestao",
        },
        {
          name: "Inovação & Cultura Ágil",
          icon: "https://files.voitto.com.br/icon-inovacao.png",
          id: 5,
          area: "inovacao-e-cultura-agil",
        },
        {
          name: "Desenvolvimento de Líderes",
          icon: "https://files.voitto.com.br/icon-lideres.png",
          id: 6,
          area: "desenvolvimento-de-lideres",
        },
        {
          name: "Negociação e Vendas",
          icon: "https://files.voitto.com.br/icon-negociacao.png",
          id: 7,
          area: "negociacao-e-vendas",
        },
        {
          name: "Gerenciamento de Projetos",
          icon: "https://files.voitto.com.br/icon-projetos.png",
          id: 9,
          area: "gerenciamento-de-projetos",
        },
      ],
      cursosByCat: false,
      menu_categoria: 0,
      cursos: [],
    };
  }

  EscondeElemento(id) {
    var elemento = document.getElementById(id);
    if (elemento.style.display == "none") {
      elemento.style.display = "block";
    } else {
      elemento.style.display = "none";
    }
  }

  componentDidMount() {
    var token = getToken();
    producaov2.get("cursos/listar").then((res) => {
      this.setState({ cursos: res.data });
    });
    if (token != undefined && token != "" && token != null) {
      //login(token);
      token = token.replace("https://www.voitto.com.br/OAuth?", "");
      token = token.replace("%7C/cursos", "");
      producaov2.get("empresa/pessoas/by-token/" + token).then((res) => {
        res = res.data;

        IS_ADMIN_SET(res.is_admin);
        IS_EMPRESA_SET(res.empresa.length > 0 ? true : false);

        setUSER({
          id: res[0][0].id,
          nome:
            res[0][0].nome != "" && res[0][0].nome != undefined
              ? res[0][0].nome
              : res[0][0].email,
          foto:
            res[0][0].foto != "" && res[0][0].foto != undefined
              ? res[0][0].foto
              : "",
          email: res[0][0].email,
          is_premium: res[0][0].isAssinante,
          aluno_empresa: res["alunoEmpresa"],
        });

        this.setState({
          id: res[0][0].id,
          nome:
            res[0][0].nome != "" && res[0][0].nome != undefined
              ? res[0][0].nome
              : res[0][0].email,
          foto:
            res[0][0].foto != "" && res[0][0].foto != undefined
              ? res[0][0].foto
              : "",
          is_empresa: res.empresa.length > 0 ? res.empresa : null,
          is_premium: res[0][0].isAssinante,
          load: true,
          aluno_empresa: res["alunoEmpresa"],
        });
      });
    }
  }

  VerificaFoto() {
    if (
      getUSER().foto == "" ||
      getUSER().foto == null ||
      getUSER().foto == 0 ||
      getUSER().foto == undefined ||
      getUSER().foto == "0"
    ) {
      return (
        "https://files.voitto.com.br/ftp-files/assets/images/perfil/" +
        getUSER().nome.charAt(0).toUpperCase() +
        ".png"
      );
    } else {
      return getUSER().foto;
    }
  }

  bar_foto() {
    return (
      <div
        style={{ marginRight: "3%", marginLeft: "5%", marginBottom: "-5px" }}
      >
        <img
          className="ui avatar circular image"
          alt="Perfil"
          src={this.VerificaFoto()}
        />
        <a className="ui" style={{ color: "white", textAlign: "center" }}>
          {abrevia_nome(getUSER().nome)}
        </a>
        <i
          className="ellipsis vertical icon"
          id="icon-menu"
          onClick={() => {
            this.EscondeElemento("conf");
          }}
          style={{ float: "right", marginTop: "3%" }}
        ></i>
      </div>
    );
  }

  categoriasHabilita() {
    this.setState({ menu_deslogado_1: !this.state.menu_deslogado_1 });
  }

  activeCursosByCat(menu_categoria = 0) {
    setTimeout(() => {
      this.setState({
        menu_categoria,
      });
    }, 400);
  }

  resetSubmenu() {
    this.setState({
      menu_categoria: 0,
    });
  }

  renderCategorias() {
    return this.state.categorias.map((v) => (
      <div
        className={"divCategoria"}
        onMouseOver={() => this.activeCursosByCat(v.id)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          backgroundColor:
            this.state.menu_categoria == v.id ? "#f7f8fa" : "#FFF",
        }}
      >
        <div style={{ height: 20, width: "8%" }}>
          <img src={v.icon} style={{ width: 20, height: "100%" }} />
        </div>
        <div className="name-category">
          <p>{v.name}</p>
        </div>
        <div style={{ width: "5%" }}>
          <i className={"ui icon caret right"} />
        </div>
      </div>
    ));
  }

  returnSubCategoria() {
    return separa_em_area_corporativa(
      this.state.cursos.cursos,
      this.state.menu_categoria
    ).map((v) => {
      return (
        <a
          target="_blank"
          className="item-subcategoria"
          href={`/digital/${v.url_amigavel}`}
          style={{
            color: "black!important",
            display: "flex",
            lineHeight: 1.2,
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: 0,
            margin: 0,
          }}
        >
          <p style={{ color: "black" }}>{limpar_titulo(v.titulo)}</p>
        </a>
      );
    });
  }

  returnCategoriaById(id = 1, param = "") {
    let object = [];
    this.state.categorias.map((v) => {
      if (v.id == id) {
        if (param == "") {
          object = v;
        } else {
          object = v[param];
        }
      }
    });
    return object;
  }

  render() {
    return (
      <div
        style={{
          width: "100vw",
          position: "fixed",
          left: 0,
          right: 0,
          backgroundColor: "#000",
          top: 0,
          zIndex: 999999,
          padding: 10,
        }}
      >
        <div
          onClick={() => {
            this.setState({ display: !this.state.display });
          }}
          style={{
            zIndex: 10000,
            position: "absolute",
            left: 10,
            top: 15,
            padding: 10,
          }}
          className="item"
        >
          <i
            className="ui bars icon"
            style={{ color: "white", fontSize: 25 }}
          ></i>
        </div>
        <center>
          <a href="/">
            <img
              src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
              style={{ width: 70, marginTop: 10 }}
            />
          </a>
          {isAuthenticated() && (
            <a
              href="/sair"
              style={{
                color: "#fff",
                position: "absolute",
                right: "10px",
                top: "20px",
                padding: "10px",
              }}
            >
              <i className="sign in icon"></i>SAIR
            </a>
          )}
          {!isAuthenticated() && (
            <a
              href="/login"
              style={{
                color: "#fff",
                position: "absolute",
                right: "10px",
                top: "20px",
                padding: "10px",
              }}
            >
              <i className="sign in icon"></i>LOGIN
            </a>
          )}
        </center>
        {isAuthenticated() && (
          <div style={{ display: this.state.display ? "block" : "none" }}>
            <div id="item_droper">{this.bar_foto()}</div>
            <div id="conf" style={{ display: "none" }}>
              <div className="ui divider"></div>
              <a href="/online/editar-perfil">
                <p id="item_droper">
                  <i className="edit outline icon" id="icon-menu"></i>EDITAR
                  PERFIL
                </p>
              </a>
            </div>
          </div>
        )}

        <div
          style={{
            backgroundColor: "#000",
            width: "100%",
            height: "70vh",
            display: this.state.display ? "block" : "none",
            overflowY: "scroll",
          }}
        >
          <div className="ui divider"></div>

          <a href="/sobrenos">
            <p id="item_droper">
              <i className="book icon" id="icon-menu"></i>SOBRE NÓS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/cursos">
            <p id="item_droper">
              <i className="ui icon play" id="icon-menu"></i> TREINAMENTOS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/lives">
            <p id="item_droper">
              <i className="ui icon red circle" id="icon-menu"></i> LIVES
            </p>
          </a>
          <div className="ui divider"></div>

          <a onClick={this.props.changeAbaNode.bind(this, "workshops")}>
            <p id="item_droper">
              <i className="ui icon archive" id="icon-menu"></i> WORKSHOPS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma">
            <p id="item_droper">
              <i className="certificate icon" id="icon-menu"></i>CERTIFICAÇÕES
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/empresas">
            <p id="item_droper">
              <i className="handshake icon" id="icon-menu"></i>ATENDIMENTO À
              EMPRESAS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/historias-de-sucesso">
            <p id="item_droper">
              <i className="star icon" id="icon-menu"></i>HISTÓRIAS DE SUCESSO
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/blog">
            <p id="item_droper">
              <i className="globe icon" id="icon-menu"></i>CONTEÚDOS GRATUITOS
            </p>
          </a>

          <div className="ui divider"></div>
          <a href="/faq">
            <p id="item_droper">
              <i className="comments outline icon" id="icon-menu"></i>CENTRAL DE
              AJUDA
            </p>
          </a>
          <div className="ui divider"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({ myaba: store.home.aba });
const mapDispathToProps = (dispatch) =>
  bindActionCreators({ changeAbaNode }, dispatch);
export default connect(mapStateToProps, mapDispathToProps)(Topo_Mobile_logoff);
